<template>
  <Modal
    :modal-active="modelValue"
    :has-header-border="true"
    :has-footer-border="true"
    max-width="max-w-md"
    @close="close"
  >
    <template #header>
      <h2 class="text-lg font-bold text-gray-700">Fluxo desabilitado</h2>
    </template>

    <div data-testid="evidence-flow-disabled-modal" class="text-sm text-gray-600">
      O envio de evidências por este fluxo está temporariamente desabilitado. Procure sua liderança
      para entender qual fluxo está sendo utilizado para o envio da evidência.
    </div>

    <template #footer>
      <div class="flex justify-end">
        <FilledButton
          text="Entendi"
          width="120px"
          data-testid="evidence-flow-disabled-ok"
          @click="close"
        />
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import Modal from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'

defineProps<{ modelValue: boolean }>()

const emit = defineEmits<{ (e: 'update:modelValue', value: boolean): void }>()

const close = () => emit('update:modelValue', false)
</script>
